import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
    selector: 'lpcr-navbar-item',
    templateUrl: './navbar-item.component.html',
    styleUrl: './navbar-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        RouterLinkActive
    ]
})
export class NavBarItemComponent {
  @Input()
  public title: string | null | undefined;

  @Input()
  public route: unknown[] | string | null | undefined;

  @Input()
  public name: string | undefined;

  @ContentChildren(NavBarItemComponent)
  public items: QueryList<NavBarItemComponent> | undefined;

  /**
   * Gets a boolean value that indicates the current nav bar item has childs.
   */
  public get hasChilds(): boolean {
    return this.items != undefined && this.items?.length > 0;
  }
}
